import React from "react";
import { Link } from "react-router";

import styles from "./Feedback.module.scss";

const Feedback: React.FC = () => {
  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    const form = e.currentTarget;
    if (!form.checkValidity()) {
      e.preventDefault();
      form.reportValidity();
      return;
    }
    e.preventDefault();
  };

  return (
    <section className={styles.feedback}>
      <div className="container">
        <div className={styles.body}>
          <div className={styles.left}>
            <h2 className={styles.title}>Нужна помощь с выбором или есть вопрос?</h2>
            <p className={styles.text}>Будем рады проконсультировать. Оставьте свой контакт, и мы свяжемся с вами</p>
          </div>
          <div className={styles.right}>
            <form onSubmit={onSubmit}>
              <div className={styles.top}>
                <div className={styles.field}>
                  <input type="text" placeholder="Имя *" />
                </div>
                <div className={styles.field}>
                  <input type="text" placeholder="Телефон *" />
                </div>
              </div>
              <div className={styles.field}>
                <input type="email" placeholder="Email *" />
              </div>
              <div className={styles.field}>
                <textarea placeholder="Вопрос или комментарий *" />
              </div>
              <div className={styles.submit}>
                <button>Отправить</button>
              </div>
              <div className={styles.rights}>
                <input type="checkbox" name="personalDataConsent" required />
                <p>
                  Я даю согласие на <Link to="/policy">обработку моих персональных данных</Link> и принимаю условия{" "}
                  <Link to="/privacy">политики конфиденциальности</Link>
                </p>
              </div>
            </form>
          </div>
        </div>
        <div className={styles.mobileBody}>
          <h2 className={styles.title}>Нужна помощь с выбором или есть вопрос?</h2>
          <p className={styles.text}>Будем рады проконсультировать</p>
          <div className={styles.links}>
            <div className={styles.link}>
              <svg width="30px" height="30px" viewBox="0 0 20 20" version="1.1" fill="#000000">
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Dribbble-Light-Preview" transform="translate(-300.000000, -7599.000000)" fill="#ffffff">
                      <g id="icons" transform="translate(56.000000, 160.000000)">
                        <path
                          d="M259.821,7453.12124 C259.58,7453.80344 258.622,7454.36761 257.858,7454.53266 C257.335,7454.64369 256.653,7454.73172 254.355,7453.77943 C251.774,7452.71011 248.19,7448.90097 248.19,7446.36621 C248.19,7445.07582 248.934,7443.57337 250.235,7443.57337 C250.861,7443.57337 250.999,7443.58538 251.205,7444.07952 C251.446,7444.6617 252.034,7446.09613 252.104,7446.24317 C252.393,7446.84635 251.81,7447.19946 251.387,7447.72462 C251.252,7447.88266 251.099,7448.05372 251.27,7448.3478 C251.44,7448.63589 252.028,7449.59418 252.892,7450.36341 C254.008,7451.35771 254.913,7451.6748 255.237,7451.80984 C255.478,7451.90987 255.766,7451.88687 255.942,7451.69881 C256.165,7451.45774 256.442,7451.05762 256.724,7450.6635 C256.923,7450.38141 257.176,7450.3464 257.441,7450.44643 C257.62,7450.50845 259.895,7451.56477 259.991,7451.73382 C260.062,7451.85686 260.062,7452.43903 259.821,7453.12124 M254.002,7439 L253.997,7439 L253.997,7439 C248.484,7439 244,7443.48535 244,7449 C244,7451.18666 244.705,7453.21526 245.904,7454.86076 L244.658,7458.57687 L248.501,7457.3485 C250.082,7458.39482 251.969,7459 254.002,7459 C259.515,7459 264,7454.51465 264,7449 C264,7443.48535 259.515,7439 254.002,7439"
                          id="whatsapp-[#ffffff]"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
              <p>
                Написать <br /> в WhatsApp
              </p>
            </div>
            <div className={styles.link}>
              <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M5.13641 12.764L8.15456 9.08664C8.46255 8.69065 8.61655 8.49264 8.69726 8.27058C8.76867 8.07409 8.79821 7.86484 8.784 7.65625C8.76793 7.42053 8.67477 7.18763 8.48846 6.72184L7.77776 4.9451C7.50204 4.25579 7.36417 3.91113 7.12635 3.68522C6.91678 3.48615 6.65417 3.35188 6.37009 3.29854C6.0477 3.238 5.68758 3.32804 4.96733 3.5081L3 4C3 14 9.99969 21 20 21L20.4916 19.0324C20.6717 18.3121 20.7617 17.952 20.7012 17.6296C20.6478 17.3456 20.5136 17.0829 20.3145 16.8734C20.0886 16.6355 19.7439 16.4977 19.0546 16.222L17.4691 15.5877C16.9377 15.3752 16.672 15.2689 16.4071 15.2608C16.1729 15.2536 15.9404 15.3013 15.728 15.4001C15.4877 15.512 15.2854 15.7143 14.8807 16.119L11.8274 19.1733M12.9997 7C13.9765 7.19057 14.8741 7.66826 15.5778 8.37194C16.2815 9.07561 16.7592 9.97326 16.9497 10.95M12.9997 3C15.029 3.22544 16.9213 4.13417 18.366 5.57701C19.8106 7.01984 20.7217 8.91101 20.9497 10.94"
                    stroke="#ffffff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </g>
              </svg>
              <p>Позвонить</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Feedback;
